import React from 'react';
import { Sparkles, Video, Utensils, CheckCircle2 } from 'lucide-react';
import { content } from '../data/content';

const Services = () => {
  const services = [
    {
      icon: Sparkles,
      title: content.services.brandMarketing.title,
      items: content.services.brandMarketing.items,
      gradient: 'from-amber-600 to-amber-700'
    },
    {
      icon: Video,
      title: content.services.shootingMedia.title,
      items: content.services.shootingMedia.items,
      gradient: 'from-amber-500 to-orange-600'
    },
    {
      icon: Utensils,
      title: content.services.eventFood.title,
      items: content.services.eventFood.items,
      gradient: 'from-orange-600 to-orange-700'
    }
  ];

  return (
    <section id="services" className="py-32 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-24">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-amber-50 mb-8">
            Soluzioni per il tuo Brand
          </h2>
          <p className="text-xl text-amber-100/60 max-w-4xl mx-auto font-light leading-relaxed">
            Tre soluzioni strategiche per integrare il tuo brand in un'esperienza ad alto impatto visivo, operativo e comunicativo.
          </p>
          <div className="w-24 h-1 bg-amber-500/40 mx-auto mt-8"></div>
        </div>

        {/* Services Grid */}
        <div className="grid lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div
                key={index}
                className="group relative bg-gradient-to-br from-amber-50/5 to-transparent border border-amber-200/10 rounded-2xl p-10 hover:border-amber-500/30 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-amber-600/10"
              >
                {/* Icon */}
                <div className="mb-8">
                  <div className="relative inline-block">
                    <div className="absolute inset-0 bg-amber-600/20 blur-xl rounded-full group-hover:bg-amber-600/30 transition-all"></div>
                    <div className={`relative bg-gradient-to-br ${service.gradient} rounded-xl p-4 group-hover:scale-110 transition-transform duration-300`}>
                      <IconComponent className="w-8 h-8 text-amber-50" />
                    </div>
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-amber-50 mb-8 group-hover:text-amber-100 transition-colors">
                  {service.title}
                </h3>

                {/* Items */}
                <ul className="space-y-4">
                  {service.items.map((item, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <CheckCircle2 className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                      <span className="text-amber-100/70 font-light">{item}</span>
                    </li>
                  ))}
                </ul>

                {/* Hover Accent */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-600 to-orange-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-b-2xl"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
